import { render } from "./UnitsList_unit_timeago.vue?vue&type=template&id=46882cd9"
import script from "./UnitsList_unit_timeago.vue?vue&type=script&lang=js"
export * from "./UnitsList_unit_timeago.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__